import loadable from "@loadable/component";
import StatusIcon from "../../Icons/StatusIcon";
import usePatchHook from "../../customHooks/usePatchHook";
import APIS from "../../constant/EndPoint";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import ProductTypeIcon from "../../Icons/ProductTypeIcon";
const ProductTypeListListComponent = loadable(
  () => import("../../components/ProductType/ProductTypeList")
);

const ProductTypeList = () => {
  const { mutateAsync: patchUser } = usePatchHook({
    queryKey: ["product-types"],
    navigateURL: null,
  });

  const handleIsActive=async(value:boolean,id:any)=>{
    const payload = {
      is_active: value,
    };
    const url = `${APIS.PRODUCT_TYPE}${id}/`;
    const formData = payload;
    try {
      await patchUser({ url, formData });
    } catch (e) {
      console.log(e);
    }
  };
  
  const handleIsRateType = async (value: boolean, id: any) => {
    const payload = {
      is_rate_by_weight: value,
    };
    const url = `${APIS.PRODUCT_TYPE}${id}/`;
    const formData = payload;
    try {
      await patchUser({ url, formData });
    } catch (e) {
      console.log(e);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <ProductTypeIcon/>
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Product Type
        </span>
      </div>
      <ProductTypeListListComponent handleIsRateType={handleIsRateType} handleIsActive={handleIsActive} />
    </>
  );
};

export default ProductTypeList;
